module.exports = __webpack_public_path__ + "img/icon1.dff6407c.png";